/*
  HoD Klaviyo capture (A5, built 15 Oct 2026 for the 28 Oct push; LIST-GROWTH-PLAN L7 T1/T2/T5, B-audit N3/N4/N10).

  T2  Any native Shopify form with form_type "customer" or "contact" and an email: on submit, tell Klaviyo who the
      visitor is (klaviyo.identify). Identification only; it never creates consent.
  T1  Contact-form section (data-hod-kl-mode on the <form>): only when the visitor TICKED the marketing box,
        mode "list"  -> Klaviyo client subscription to the list (email marketing only) with custom_source;
        mode "trade" -> Trade Leads list (data-hod-kl-trade-list), never the consumer list; plus profile property trade_lead=true.
      Unticked stays unticked; this script never ticks anything.
  T5  Klaviyo form submit (window "klaviyoForms" event, type "submit"): fire Meta Lead / GA4 generate_lead if the
      page has fbq / gtag (it does not today: both pixels are Shopify app web pixels, sandboxed), push a dataLayer
      event, and publish a Shopify custom event "hod_lead" that a Shopify custom pixel can forward.

  The native submit is never blocked or delayed: every network call is fire-and-forget fetch with keepalive, and
  every step is wrapped so a Klaviyo failure cannot throw into the page.
*/
(function () {
  'use strict';
  if (window.__hodKlCapture) { return; }
  window.__hodKlCapture = true;

  var COMPANY_ID = 'YkmZPB';
  var REVISION = '2026-07-15';
  var BASE = 'https://a.klaviyo.com/client/';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var sent = {};

  function post(path, payload) {
    try {
      if (!window.fetch) { return; }
      window.fetch(BASE + path + '?company_id=' + COMPANY_ID, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(payload)
      })['catch'](function () {});
    } catch (e) {}
  }

  function identify(props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        var p = window.klaviyo.identify(props);
        if (p && typeof p['catch'] === 'function') { p['catch'](function () {}); }
      }
    } catch (e) {}
  }

  function field(form, name) {
    try { return form.querySelector('[name="' + name + '"]'); } catch (e) { return null; }
  }

  function onSubmit(evt) {
    try {
      var form = evt.target;
      if (!form || form.tagName !== 'FORM') { return; }
      var typeInput = field(form, 'form_type');
      var formType = typeInput ? typeInput.value : '';
      if (formType !== 'customer' && formType !== 'contact') { return; }

      // Honeypot (contact-form section): a filled "website" field is a bot; send nothing.
      var trap = field(form, 'website');
      if (trap && trap.value) { return; }

      var emailInput = field(form, 'contact[email]') || form.querySelector('input[type="email"]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!EMAIL_RE.test(email)) { return; }

      var key = (form.id || formType) + '|' + email.toLowerCase();
      if (sent[key]) { return; }
      sent[key] = true;

      var nameInput = field(form, 'contact[name]');
      var fullName = nameInput ? String(nameInput.value || '').trim() : '';
      var idProps = { email: email };
      if (fullName) {
        var parts = fullName.split(/\s+/);
        idProps.first_name = parts.shift();
        if (parts.length) { idProps.last_name = parts.join(' '); }
      }

      // T1: contact-form section only, and only when the marketing box is ticked.
      var mode = form.getAttribute('data-hod-kl-mode');
      var optIn = field(form, 'contact[marketing_opt_in]');
      var ticked = !!(optIn && optIn.checked);

      if (mode === 'trade' && ticked) {
        idProps.trade_lead = true;
        idProps.trade_lead_source = form.getAttribute('data-hod-kl-source') || 'HoD wholesale form';
        var topic = field(form, 'contact[topic]');
        if (topic && topic.value) { idProps.trade_lead_type = topic.value; }
      }

      // T2 (and T1 identify): runs for every native customer/contact form submit.
      identify(idProps);

      if (!ticked || !mode) { return; }

      if (mode === 'list') {
        var listId = form.getAttribute('data-hod-kl-list');
        if (!listId) { return; }
        post('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('data-hod-kl-source') || 'HoD contact form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        });
      } else if (mode === 'trade') {
        // No list. Belt and braces for identify (which may not finish before the page navigates).
        var attrs = { email: email, properties: { trade_lead: true, trade_lead_source: idProps.trade_lead_source } };
        if (idProps.trade_lead_type) { attrs.properties.trade_lead_type = idProps.trade_lead_type; }
        if (idProps.first_name) { attrs.first_name = idProps.first_name; }
        if (idProps.last_name) { attrs.last_name = idProps.last_name; }
        post('profiles', { data: { type: 'profile', attributes: attrs } });
        var tradeList = form.getAttribute('data-hod-kl-trade-list');
        if (tradeList) {
          post('subscriptions', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: idProps.trade_lead_source,
                profile: { data: { type: 'profile', attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: tradeList } } }
            }
          });
        }
      }
    } catch (e) {}
  }

  // Capture phase so we see the submit before any handler that navigates; we never call preventDefault.
  document.addEventListener('submit', onSubmit, true);

  // T5: Klaviyo onsite form submitted an email.
  var leadSent = {};
  window.addEventListener('klaviyoForms', function (e) {
    try {
      var d = e && e.detail;
      if (!d || d.type !== 'submit') { return; }
      var formId = String(d.formId || 'unknown');
      if (leadSent[formId]) { return; }
      leadSent[formId] = true;
      var payload = { form_id: formId, source: 'klaviyo_form', page: location.pathname };
      // Email for Meta manual advanced matching in the Lead custom pixel (the sandbox can't auto-match).
      var md = d.metaData || {};
      var em = String(md.email || md.$email || '').trim().toLowerCase();
      if (EMAIL_RE.test(em)) { payload.email = em; }

      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Klaviyo form ' + formId });
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { form_id: formId, method: 'klaviyo_form' });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', form_id: formId, method: 'klaviyo_form' });

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hod_lead', payload);
      }
    } catch (err) {}
  });
})();
